import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Box,
} from '@mui/material';

const NavigationBar = ({ userName, userEmail, tenantId, onLogout }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: '#1e3a5f', // Dark navy blue
        boxShadow: '2px 0 5px rgba(0, 0, 0, 1)', // Soft shadow
      }}
    >
      <Toolbar>
        {/* Logo and Title */}
        <Box display="flex" alignItems="center" sx={{ flexGrow: 1 }}>
          {/* Logo */}
          <img
            src="/pub/logo.svg" // Path to your logo
            alt="Logo"
            style={{
              height: '50px', // Adjust the size as needed
              marginRight: '50px',
              filter: 'brightness(0) invert(1)', // Makes it white
            }}
          />
          {/* App Name */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'normal',
              color: 'white', // White text for visibility
              fontFamily: 'Noto Sans, sans-serif', // Apply Noto Sans
              fontSize: '29px', // Adjust font size if needed
              letterSpacing: '0.5px', // Optional spacing for style,
              paddingBottom: '5px'
            }}
          >
            Success Suite
          </Typography>
        </Box>

        {/* User Avatar and Info */}
        <Avatar
          alt="User Photo"
          src=""
          onClick={handleMenuOpen}
          sx={{
            cursor: 'pointer',
            marginRight: '10px',
            backgroundColor: 'white', // White circle background for contrast
            color: '#1e3a5f', // Matches the navy background
          }}
        />
        <Typography
          variant="subtitle1"
          onClick={handleMenuOpen}
          sx={{
            cursor: 'pointer',
            fontWeight: 'normal',
            color: 'white', // White text
          }}
        >
          {userName}
        </Typography>

        {/* Dropdown Menu */}
        <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
          <MenuItem disabled>Name: {userName}</MenuItem>
          <MenuItem disabled>Email: {userEmail}</MenuItem>
          <MenuItem disabled>Tenant ID: {tenantId}</MenuItem>
          <Divider />
          <MenuItem onClick={onLogout}>Sign Out</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;